import { createContext, useState } from "react";

export const NavContext = createContext({
    isClicked: false,
});


const NavProvider = ({children}) => {
    const[isClicked, setisClicked] = useState(false);
    const values = {isClicked, setisClicked};

    return <NavContext.Provider value={values}>{children}</NavContext.Provider>
}

export default NavProvider;